import styled, { css } from "styled-components";

export const StyledScheduleCard = styled.div<{
    $hasDebt?: boolean;
    $selected?: boolean;
}>`
    touch-action: manipulation;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 8px;
    padding: 16px;
    position: relative;
    background-color: ${(props) => props.theme.secondaryBackgroundColor};
    border: 1px solid ${(props) => props.theme.secondaryBorderColor};
    overflow: hidden;

    ${({ $selected, theme }) =>
        $selected
            ? css`
                  background-color: ${theme.itemBackground};
                  border: 1px solid ${theme.colors.primary};
              `
            : null}

    &::before {
        display: ${(props) => (props.$hasDebt ? "block" : "none")};
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background-color: ${(props) => props.theme.dangerTypographyColor};
    }
`;
